<template>
    <div class="how_it_works">
        <div class="title-block">
            <div>
                <span class="title">How it works</span>
                <div class="right-circle">
                    <div class="white-circle"></div>
                </div>
            </div>
            <!--<span class="title-description">Lorem Ipsum dolor sit amet. Lorem Ipsum dolor sit amet.</span>-->
        </div>
        <div class="steps-block">
            <div class="step-card">
                <div class="img_wrapper">
                    <img src="../../../assets/svgs/HowItWorks/Group_7943.svg" />
                </div>
                <p class="active">1. Enter flight destination and dates.</p>
            </div>
            <div class="step-card">
                <div class="img_wrapper">
                    <img src="../../../assets/svgs/HowItWorks/Group_7944.svg" />
                </div>
                <p>2. Fill in your contact information.</p>
            </div>
            <div class="step-card">
                <div class="img_wrapper">
                    <img src="../../../assets/svgs/HowItWorks/noun_customer_2632826.svg" />
                </div>
                <p>3. Our travel experts will respond shortly to assist.</p>
            </div>
            <div class="step-card">
                <div class="img_wrapper">
                    <img src="../../../assets/svgs/HowItWorks/noun_Flight_1557460.svg" />
                </div>
                <p>4. Check inbox for best deals.</p>
            </div>
        </div>
        <button class="btn">Find Flights</button>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'HowItWorks',
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/global-styles';

.how_it_works {
    width: 100%;
    max-width: 1250px;
    margin: 0 auto;
    padding: 50px 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 30px;

        div {
            position: relative;

            .title {
                font-size: 36px;
                line-height: 55px;
            }

            .right-circle {
                width: 36px;
                height: 36px;
                background: transparent linear-gradient(180deg, #fec183 0%, #fea880 17%, #fe6b7a 54%, #ff1572 100%) 0%
                    0% no-repeat padding-box;
                border-radius: 50%;
                position: absolute;
                top: -10px;
                right: -40px;

                .white-circle {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    position: absolute;
                    z-index: 2;
                    background-color: white;
                    top: 8px;
                    left: 8px;
                }
            }
        }

        .title-description {
            font-family: 'Gilroy-Light', sans-serif;
            font-size: 18px;
            line-height: 27px;
            color: $mainTextBlueColor;
        }
    }

    .steps-block {
        display: flex;
        width: 100%;

        justify-content: space-between;
        padding-bottom: 30px;

        .step-card {
            width: 20%;

            .img_wrapper {
                width: 80px;
                height: 80px;
                background: #ffffff 0% 0% no-repeat padding-box;
                box-shadow: 0px 3px 20px #0000000d;
                opacity: 1;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            p {
                font-family: 'Poppins-Light', sans-serif;
                font-size: 18px;
                line-height: 27px;
                color: #757598;
                letter-spacing: 0;
            }

            .active {
                font-family: 'Poppins-SemiBold', sans-serif;
                color: $mainTextBlueColor;
            }
        }
    }

    @media (max-width: 768px) {
        .title-block {
            div {
                .title {
                    font-size: 28px;
                    line-height: 42px;
                }

                .right-circle {
                    top: -15px;
                    right: -45px;
                }
            }

            .title-description {
                font-size: 13px;
                line-height: 20px;
                text-align: center;
            }
        }

        .steps-block {
            flex-direction: column;

            .step-card {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/HowItWorks.vue